export const ACCOUNT_SAVE_START = 'ACCOUNT_SAVE_START';
export const ACCOUNT_SAVE_LOADING = 'ACCOUNT_SAVE_LOADING';
export const ACCOUNT_SAVE_ERROR = 'ACCOUNT_SAVE_ERROR';
export const ACCOUNT_SAVE_SUCCESS = 'ACCOUNT_SAVE_SUCCESS';

export const ADDRESS_SAVE_START = 'ADDRESS_SAVE_START';
export const ADDRESS_SAVE_LOADING = 'ADDRESS_SAVE_LOADING';
export const ADDRESS_SAVE_ERROR = 'ADDRESS_SAVE_ERROR';
export const ADDRESS_SAVE_SUCCESS = 'ADDRESS_SAVE_SUCCESS';

export const EMAIL_SAVE_START = 'EMAIL_SAVE_START';
export const EMAIL_SAVE_ERROR = 'EMAIL_SAVE_ERROR';
export const EMAIL_SAVE_SUCCESS = 'EMAIL_SAVE_SUCCESS';
export const RESET_EMAIL_FORM = 'RESET_EMAIL_FORM';

export const AUTO_COFE_SAVE_START = 'AUTO_COFE_SAVE_START';
export const AUTO_COFE_SAVE_ERROR = 'AUTO_COFE_SAVE_ERROR';
export const AUTO_COFE_SAVE_SUCCESS = 'AUTO_COFE_SAVE_SUCCESS';

export const FETCH_ACCTS_START = 'FETCH_ACCTS_START';
export const FETCH_ACCTS_SUCCESS = 'FETCH_ACCTS_SUCCESS';
export const FETCH_ACCTS_ERROR = 'FETCH_ACCTS_ERROR';

export const FETCH_OFFERS_START = 'FETCH_OFFERS_START';
export const FETCH_OFFERS_SUCCESS = 'FETCH_OFFERS_SUCCESS';
export const FETCH_OFFERS_ERROR = 'FETCH_OFFERS_ERROR';

export const RESET_PASSWORD_START = 'RESET_PASSWORD_START';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const CANCEL_RESET_PASSWORD_FORM = 'CANCEL_RESET_PASSWORD_FORM';

import { UpdateEmailResponse } from '@src/app/_global/domain';
import { ResetPasswordResponse } from '@src/_api/payload/reset-password';

export type Actions = {
  ACCOUNT_SAVE_START: { type: typeof ACCOUNT_SAVE_START; payload: any };
  ACCOUNT_SAVE_LOADING: { type: typeof ACCOUNT_SAVE_LOADING; payload: boolean };
  ACCOUNT_SAVE_ERROR: { type: typeof ACCOUNT_SAVE_ERROR; payload: any };
  ACCOUNT_SAVE_SUCCESS: { type: typeof ACCOUNT_SAVE_SUCCESS; payload: any };
  FETCH_ACCTS_START: { type: typeof FETCH_ACCTS_START; payload: string };
  FETCH_ACCTS_SUCCESS: { type: typeof FETCH_ACCTS_SUCCESS; payload: any };
  FETCH_ACCTS_ERROR: { type: typeof FETCH_ACCTS_ERROR; payload: any };
  FETCH_OFFERS_START: { type: typeof FETCH_OFFERS_START; payload: string };
  FETCH_OFFERS_SUCCESS: { type: typeof FETCH_OFFERS_SUCCESS; payload: any };
  FETCH_OFFERS_ERROR: { type: typeof FETCH_OFFERS_ERROR; payload: any };
  ADDRESS_SAVE_START: { type: typeof ADDRESS_SAVE_START; payload: any };
  ADDRESS_SAVE_LOADING: { type: typeof ADDRESS_SAVE_LOADING; payload: boolean };
  ADDRESS_SAVE_ERROR: { type: typeof ADDRESS_SAVE_ERROR; payload: any };
  ADDRESS_SAVE_SUCCESS: { type: typeof ADDRESS_SAVE_SUCCESS; payload: any };
  EMAIL_SAVE_START: { type: typeof EMAIL_SAVE_START; payload: any };
  EMAIL_SAVE_ERROR: { type: typeof EMAIL_SAVE_ERROR; payload: any };
  EMAIL_SAVE_SUCCESS: { type: typeof EMAIL_SAVE_SUCCESS; payload: any };
  RESET_EMAIL_FORM: { type: typeof RESET_EMAIL_FORM; payload: boolean };
  AUTO_COFE_SAVE_START: { type: typeof AUTO_COFE_SAVE_START; payload: any };
  AUTO_COFE_SAVE_ERROR: { type: typeof AUTO_COFE_SAVE_ERROR; payload: any };
  AUTO_COFE_SAVE_SUCCESS: { type: typeof AUTO_COFE_SAVE_SUCCESS; payload: any };
  RESET_PASSWORD_START: { type: typeof RESET_PASSWORD_START; payload: any };
  RESET_PASSWORD_ERROR: { type: typeof RESET_PASSWORD_ERROR; payload: any };
  RESET_PASSWORD_SUCCESS: { type: typeof RESET_PASSWORD_SUCCESS; payload: any };
  CANCEL_RESET_PASSWORD_FORM: { type: typeof CANCEL_RESET_PASSWORD_FORM; payload: boolean };
};

// Action Creators
export const actionCreators = {
  accountSaveStart: (payload: any): Actions[typeof ACCOUNT_SAVE_START] => ({
    type: ACCOUNT_SAVE_START,
    payload,
  }),
  accountSaveError: (payload: any): Actions[typeof ACCOUNT_SAVE_ERROR] => ({
    type: ACCOUNT_SAVE_ERROR,
    payload,
  }),
  accountSaveSuccess: (payload: any): Actions[typeof ACCOUNT_SAVE_SUCCESS] => ({
    type: ACCOUNT_SAVE_SUCCESS,
    payload,
  }),
  accountSaveLoading: (
    payload: boolean,
  ): Actions[typeof ACCOUNT_SAVE_LOADING] => ({
    type: ACCOUNT_SAVE_LOADING,
    payload,
  }),
  fetchAccountsSuccess: (
    payload: any,
  ): Actions[typeof FETCH_ACCTS_SUCCESS] => ({
    type: FETCH_ACCTS_SUCCESS,
    payload,
  }),
  fetchAccountsStart: (payload: string): Actions[typeof FETCH_ACCTS_START] => ({
    type: FETCH_ACCTS_START,
    payload,
  }),
  addressSaveStart: (payload: any): Actions[typeof ADDRESS_SAVE_START] => ({
    type: ADDRESS_SAVE_START,
    payload,
  }),
  addressSaveError: (payload: any): Actions[typeof ADDRESS_SAVE_ERROR] => ({
    type: ADDRESS_SAVE_ERROR,
    payload,
  }),
  addressSaveSuccess: (payload: any): Actions[typeof ADDRESS_SAVE_SUCCESS] => ({
    type: ADDRESS_SAVE_SUCCESS,
    payload,
  }),
  addressSaveLoading: (
    payload: boolean,
  ): Actions[typeof ADDRESS_SAVE_LOADING] => ({
    type: ADDRESS_SAVE_LOADING,
    payload,
  }),
  emailSaveStart: (payload: any): Actions[typeof EMAIL_SAVE_START] => ({
    type: EMAIL_SAVE_START,
    payload,
  }),
  emailSaveError: (payload: any): Actions[typeof EMAIL_SAVE_ERROR] => ({
    type: EMAIL_SAVE_ERROR,
    payload,
  }),
  emailSaveSuccess: (
    payload: UpdateEmailResponse,
  ): Actions[typeof EMAIL_SAVE_SUCCESS] => ({
    type: EMAIL_SAVE_SUCCESS,
    payload,
  }),

  autoCofeSaveStart: (payload: any): Actions[typeof AUTO_COFE_SAVE_START] => ({
    type: AUTO_COFE_SAVE_START,
    payload,
  }),
  autoCofeSaveError: (payload: any): Actions[typeof AUTO_COFE_SAVE_ERROR] => ({
    type: AUTO_COFE_SAVE_ERROR,
    payload,
  }),
  autoCofeSaveSuccess: (
    payload: UpdateEmailResponse,
  ): Actions[typeof AUTO_COFE_SAVE_SUCCESS] => ({
    type: AUTO_COFE_SAVE_SUCCESS,
    payload,
  }),

  resetEmail: (payload: boolean): Actions[typeof RESET_EMAIL_FORM] => ({
    type: RESET_EMAIL_FORM,
    payload,
  }),
  fetchOffersSuccess: (payload: any): Actions[typeof FETCH_OFFERS_SUCCESS] => ({
    type: FETCH_OFFERS_SUCCESS,
    payload,
  }),
  fetchOffersFailure: (
    payload: string,
  ): Actions[typeof FETCH_OFFERS_ERROR] => ({
    type: FETCH_OFFERS_ERROR,
    payload,
  }),
  fetchOffersStart: (payload: any): Actions[typeof FETCH_OFFERS_START] => ({
    type: FETCH_OFFERS_START,
    payload,
  }),
  
  resetPasswordStart: (payload: any): Actions[typeof RESET_PASSWORD_START] => ({
    type: RESET_PASSWORD_START,
    payload,
  }),
  resetPasswordError: (payload: any): Actions[typeof RESET_PASSWORD_ERROR] => ({
    type: RESET_PASSWORD_ERROR,
    payload,
  }),
  resetPasswordSuccess: (payload: ResetPasswordResponse): Actions[typeof RESET_PASSWORD_SUCCESS] => {
    payload.history.push('/accounts/summary');
    return ({ type: RESET_PASSWORD_SUCCESS, payload: payload});
  },
  cancelResetPassword: (payload: boolean): Actions[typeof CANCEL_RESET_PASSWORD_FORM] => ({
    type: CANCEL_RESET_PASSWORD_FORM,
    payload,
  }),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/summary/actions.ts